import React from 'react';
import ReactGA4 from 'react-ga4';
import SearchInput, { createFilter } from 'react-search-input';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import { FIXED_DUTY_STATE, VALID_RANKS } from '../../../utils/examConstants';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { SignUpDesktop, SignUpMobile } from '../../Common/const';

class SignUpSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRate: {
        id: 0,
        shortname: 'First, choose your AFSC.',
        isPfeOnly: false,
      },
      rateSelectorIsOpen: false,
      selectedRank: 'Exam Paygrade',
      rankSelectorIsOpen: false,
      searchTerm: '',
      rateTracked: false,
      paygradeTracked: false,
      signUpTracked: false,
    };
  }

  handleRateSelectorClick = () => {
    this.setState({
      rateSelectorIsOpen: !this.state.rateSelectorIsOpen,
      searchTerm: '',
    });
  };

  handleRateOptionClick = (rate) => {
    this.setState({
      selectedRate: rate,
      selectedRank: 'Exam Paygrade',
    });

    if (rate.shortname) {
      ReactGA4.event({
        category: 'Select',
        action: `Select an AFSC before Sign-up form - ${rate.shortname}`,
        label: `Select an AFSC before Sign-up form - ${rate.shortname}`,
      });
    }

    this.props.updateFormState({ rate, dutyState: FIXED_DUTY_STATE });

    if (
      rate.id !== 0 &&
      this.state.selectedRank !== 'Exam Paygrade' &&
      rate.id !== this.state.selectedRate.id
    ) {
      // this.props.loadQualsData();
      this.props.loadReferences(
        rate.id,
        this.state.selectedRank,
        FIXED_DUTY_STATE,
      );
    }
  };

  handleRankSelectorClick = () => {
    this.setState({ rankSelectorIsOpen: !this.state.rankSelectorIsOpen });
  };

  handleRankOptionClick = (rank) => {
    this.setState({ selectedRank: rank });
    this.props.updateFormState({ rank });

    if (
      this.state.selectedRate.id !== 0 &&
      rank !== 'Exam Paygrade' &&
      rank !== this.state.selectedRank
    ) {
      this.props.loadReferences(
        this.state.selectedRate.id,
        rank,
        FIXED_DUTY_STATE,
      );
      // this.props.loadQualsData();
    }
  };

  searchUpdated = (term) => {
    this.setState({ searchTerm: term });
  };

  captureAnalyticsEvent = (action, label, type) => {
    if (
      (type === 'rate' && !this.state.rateTracked) ||
      (type === 'paygrade' && !this.state.paygradeTracked)
    ) {
      // Google Analytics 4
      ReactGA4.event({
        category: 'Select',
        action,
        label,
      });
      if (type === 'rate') {
        this.setState({ rateTracked: true });
      } else if (type === 'paygrade') {
        this.setState({ paygradeTracked: true });
      }
    }
  };

  renderRateSelector = () => {
    const filteredRates = this.props.rates
      .filter(createFilter(this.state.searchTerm, ['shortname']))
      .sort((a, b) => {
        if (a.shortname < b.shortname) {
          return -1;
        }
        if (a.shortname > b.shortname) {
          return 1;
        }
        return 0;
      });
    return (
      <div
        className="field"
        onClick={() =>
          this.captureAnalyticsEvent(
            'Select an AFSC in Sign-up form',
            'First, choose your AFSC',
            'AFSC',
          )
        }
      >
        <Dropdown
          isOpen={this.state.rateSelectorIsOpen}
          toggle={this.handleRateSelectorClick}
          className="signup-sidebar-selector"
          data-test="rate-dropdown"
        >
          <DropdownToggle className="signup-sidebar-dropdown-toggle">
            <span className="option-title">
              {`${this.state.selectedRate.shortname}`}
            </span>
            {this.state.rateSelectorIsOpen ? (
              <i className="icon-expand select-icon rotate down" />
            ) : (
              <i className="icon-expand select-icon rotate" />
            )}
          </DropdownToggle>
          <DropdownMenu className="rate-menu">
            <SignUpDesktop>
              <SearchInput
                className="search-input rate-filter"
                onChange={this.searchUpdated}
                autoFocus
              />
            </SignUpDesktop>
            <SignUpMobile>
              <SearchInput
                className="search-input rate-filter"
                onChange={this.searchUpdated}
                autoFocus={false}
              />
            </SignUpMobile>

            {filteredRates.map((rate) => (
              <DropdownItem
                className="drop-item"
                key={rate.id}
                onClick={() => this.handleRateOptionClick(rate)}
                data-test={`rate-dropdown-item-${rate.shortname}`}
              >
                <span>{rate.shortname}</span>
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  renderRankSelector = () => {
    const filteredRates = this.props.rates.filter(
      (rate) => rate.id === this.state.selectedRate.id,
    );

    // Check if any valid exam (E5 or E6 Regular) exists for this rate
    const hasValidExams =
      filteredRates.length > 0 &&
      filteredRates[0] &&
      ((filteredRates[0].e5_regular !== undefined &&
        !filteredRates[0].e5_regular) ||
        (filteredRates[0].e6_regular !== undefined &&
          !filteredRates[0].e6_regular));

    return (
      <div
        className="field"
        onClick={() =>
          this.captureAnalyticsEvent(
            'Select a paygrade in Sign-up form',
            'Exam Paygrade',
            'paygrade',
          )
        }
      >
        <Dropdown
          isOpen={this.state.rankSelectorIsOpen}
          toggle={this.handleRankSelectorClick}
          className="signup-sidebar-selector"
          disabled={this.state.selectedRate.id === 0}
          data-test="exam-paygrade-dropdown"
        >
          <DropdownToggle className="signup-sidebar-dropdown-toggle">
            <span className="option-title">{this.state.selectedRank}</span>
            {this.state.rankSelectorIsOpen ? (
              <i className="icon-expand select-icon rotate down" />
            ) : (
              <i className="icon-expand select-icon rotate" />
            )}
          </DropdownToggle>
          <DropdownMenu>
            {!hasValidExams ? (
              <DropdownItem
                className="drop-item"
                key="No Exam Paygrade available for this exam"
                disabled
              >
                No Exam Paygrade available for this exam
              </DropdownItem>
            ) : (
              <>
                <DropdownItem
                  className="drop-item message-rank-studyFor"
                  disabled
                >
                  This is the rank you are studying FOR, <br /> and not the rank
                  you currently ARE.
                </DropdownItem>
                {filteredRates.map((rate) => (
                  <React.Fragment key={rate.id}>
                    {VALID_RANKS.map((rank) => {
                      const examKey = `${rank.toLowerCase()}_regular`;
                      const isAvailable =
                        rate[examKey] !== undefined && !rate[examKey];
                      return isAvailable ? (
                        <DropdownItem
                          className="drop-item"
                          key={rank}
                          onClick={() => this.handleRankOptionClick(rank)}
                          data-test={`exam-paygrade-dropdown-item-${rank}`}
                        >
                          {rank}
                        </DropdownItem>
                      ) : null;
                    })}
                  </React.Fragment>
                ))}
              </>
            )}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  handleButtonClick = (flag) => {
    if (!this.state.signUpTracked) {
      // Google Analytics 4
      ReactGA4.event({
        category: 'Select',
        action: 'Get 3 Day Free Trial',
        label: 'Get 3 Day Free Trial',
      });
      this.setState({ signUpTracked: true });
    }
    if (flag) {
      this.props.openSubscriptionModal(true);
    } else {
      this.props.updateFormState({ mobileStep: true });
    }
  };

  render() {
    return (
      <div className="signup-sidebar">
        <div className="signup-sidebar-title">
          Select Your AFSC Exam to Begin
        </div>
        <div className="signup-sidebar-body d-flex">
          {this.renderRateSelector()}
          {this.renderRankSelector()}
          <div className="button-container">
            <SignUpDesktop>
              <button
                className="open-modal-btn btn btn-block"
                onClick={() => this.handleButtonClick(true)}
                disabled={
                  this.state.selectedRate.id === 0 ||
                  this.state.selectedRank === 'Exam Paygrade' ||
                  this.props.loadingReferences
                }
                data-test="get-3-day-free-trial-button"
              >
                {this.props.loadingReferences ? (
                  <CircularLoading className="loading-free-trial-button" />
                ) : (
                  'Get 3 Day Free Trial'
                )}
              </button>
            </SignUpDesktop>
            <SignUpMobile>
              <button
                className="open-modal-btn btn btn-block"
                onClick={() => this.handleButtonClick(false)}
                disabled={
                  this.state.selectedRate.id === 0 ||
                  this.state.selectedRank === 'Exam Paygrade'
                }
              >
                View AFSC Exam
              </button>
            </SignUpMobile>
          </div>
          {/* <div className="messageWarOnly">
            <b>Want access to Warfare & Qualification study guides only?</b>
            <br />
            <span>
              Make the selections above, and select that pricing option on the
              payment screen.
            </span>
          </div> */}
        </div>
      </div>
    );
  }
}

export default SignUpSidebar;
